// hooks/use-isArabic.ts
"use client";

import { LanguageType } from "@/lib/types"; // Assuming this is your enum
import { useParams } from "next/navigation";

/**
 * A custom hook to determine if the current language is Arabic.
 * @returns {{isArabic: boolean, lang: LanguageType}} - An object with the isArabic boolean and the LanguageType enum.
 */
export function useIsArabic(): { isArabic: boolean; lang: LanguageType } {
  try {
    const params = useParams();
    // Safely get the lang parameter with a fallback
    const langParam = (params.lang as string) || 'en-us';

    // 1. Determine the boolean value
    const isArabic = langParam === 'ar-sa';

    // 2. Determine the corresponding enum value
    const langEnum = isArabic ? LanguageType.AR : LanguageType.EN;

    // 3. Return the object in the correct shape
    return { isArabic, lang: langEnum };

  } catch (error) {
    console.warn("useIsArabic hook should be used within a Client Component.");
    // This fallback is already in the correct shape
    return { isArabic: false, lang: LanguageType.EN };
  }
}